import { TFunction } from 'i18next';

import {
  BoardMineralization,
  BoardSoil,
  BoardStatus,
} from 'features/Croptimizer/types';
import { getEfficiencyFormula } from 'features/Croptimizer/utils/calcHelperBoard';
import { numericValues } from 'utils/helpers';

interface Props {
  getY1CurrentProfit: string;
  mineralizationValues: BoardMineralization | null;
  boardStatusValues: BoardStatus | null;
  boardSoilValues: BoardSoil | null;
  optimumValue: number;
  t: TFunction;
}

export const Y2CurrentProfitSecond = ({
  getY1CurrentProfit,
  boardStatusValues,
  mineralizationValues,
  boardSoilValues,
  optimumValue,
  t,
}: Props) => {
  const getSec = (
    ((Math.tan((Number(getY1CurrentProfit) - 5.8) / 1.45) * 54 + 70) /
      100 /
      0.05) *
    5
  ).toFixed(2);

  const ag38 = getEfficiencyFormula(
    Number(mineralizationValues?.month),
    Number(boardStatusValues?.currentPh),
    Number(numericValues(boardStatusValues?.currentSec ?? '')),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );

  const ah38 = getEfficiencyFormula(
    24,
    Number(getY1CurrentProfit),
    Number(getSec),
    // Number(boardSoilValues?.selected),
    optimumValue,
    Number(numericValues(mineralizationValues?.soilTillage ?? '')),
  );

  const ag31 = ag38;
  const ah31 = ah38 < ag31 ? ag31 : ah38;
  const ai78 = ah31 / 100;
  const ah78 = ag31 / 100;
  const ah79 = ag31 / 100;
  const ai71 = ai78 - ah78;
  const ah71 = ah78;
  const dose = Number(numericValues(boardSoilValues?.dose ?? '')) / 100;
  const ai79 = ah31 / 100;
  const ai72 = ai79 - ah79;
  const ah81 = ag31 / 100;
  const ai81 = ah31 / 100;
  const ai74 = ai81 - ah81;

  const ah80 = ag31 / 100;
  const ai80 = ah31 / 100;
  const ai73 = ai80 - ah80;
  const ai82 = ah31 / 100;
  const ah82 = ag31 / 100;
  const ai75 = ai82 - ah82;

  const annualDecrease = Number(mineralizationValues?.annualDecrease);
  const frequency = Number(boardSoilValues?.split);

  if (mineralizationValues?.cap !== t('no')) {
    if (boardSoilValues?.split === '1') {
      const ahi87 = ah71 + ai71;
      const calculatedq64 = (annualDecrease * dose * frequency * ahi87).toFixed(
        2,
      );
      const p64MinusAnnual = Number(getY1CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const ai88 = ai72;
      const calculatedq65 = (annualDecrease * dose * frequency * ai88).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.2);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const ai89 = ai73;
      const calculatedq65 = (annualDecrease * dose * frequency * ai89).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const ai90 = ai74;
      const calculatedq65 = (annualDecrease * dose * frequency * ai90).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const ai91 = ai75;
      const calculatedq65 = (annualDecrease * dose * frequency * ai91).toFixed(
        2,
      );
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + Number(calculatedq65)).toFixed(2);
    }
  } else {
    if (boardSoilValues?.split === '1') {
      const calculatedq64 = (annualDecrease * dose * frequency).toFixed(2);
      const p64MinusAnnual = Number(getY1CurrentProfit) - annualDecrease;

      return (p64MinusAnnual + Number(calculatedq64)).toFixed(2);
    }

    if (boardSoilValues?.split === '2') {
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.2);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '3') {
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.3);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '4') {
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.4);

      return (p64MinusAnnual + 0).toFixed(2);
    }

    if (boardSoilValues?.split === '5') {
      const p64MinusAnnual =
        Number(getY1CurrentProfit) - annualDecrease * (1 + 1 * 0.5);

      return (p64MinusAnnual + 0).toFixed(2);
    }
  }
};
